/**
 * The Legate mark.
 *
 * The brand asset is a raster plate — a blue stroke on a pale lavender ground —
 * so it is rendered as an image rather than as `currentColor` paths. It keeps
 * its own colour everywhere, which is what makes it read as a mark rather than
 * as another piece of interface chrome.
 */
export function Logo({ className = 'w-6 h-6' }: { className?: string }) {
  return (
    <img
      src="/legate-mark-256.png"
      srcSet="/legate-mark-96.png 96w, /legate-mark-256.png 256w, /legate-mark-512.png 512w"
      sizes="32px"
      alt=""
      aria-hidden="true"
      draggable={false}
      className={`${className} rounded-[5px] object-cover select-none`}
    />
  );
}

export default Logo;
